import { Pipe, PipeTransform } from '@angular/core';
import { MandantenData } from '../../providers/mandanten-data';

@Pipe({
  name: 'mandatename'
})
export class MandatenamePipe implements PipeTransform {
  constructor(private ms: MandantenData) {}
  transform(value: any, args?: any) {
    return this.ms.getMandateName(value);
  }

}


// WEBPACK FOOTER //
// ./src/pipes/mandatename/mandatename.ts